/**
 * Labstep
 *
 * @module core/Sortable/Table
 * @desc Component for sorting table
 */

import { Sortable } from 'labstep-web/core/Sortable';
import { SortableContainer } from 'labstep-web/core/Sortable/Container';
import type React from 'react';
import { Table } from 'semantic-ui-react';
import type { ISortableTableProps } from './types';

export const SortableTable: React.FC<ISortableTableProps> = ({
  renderItem,
  disabled,
  className,
  isTableBody,
  ...rest
}) => (
  <SortableContainer
    {...rest}
    render={({ items, onSortEnd }): JSX.Element => {
      const Container = isTableBody ? Table.Body : Table;
      return (
        <Container className={className}>
          <Sortable
            renderItem={renderItem}
            items={items}
            disabled={disabled}
            onSortEnd={onSortEnd}
            hideOverlay
          />
        </Container>
      );
    }}
  />
);
